import { AssetAmount } from "@ergolabs/ergo-sdk";
import { DefaultAmmOrdersParser } from "../parsers/ammOrdersParser";
import { DefaultAmmPoolsInfoParser } from "../parsers/ammPoolsInfoParser";
export function makeHistory(network) {
    const ordersParser = new DefaultAmmOrdersParser();
    const poolParser = new DefaultAmmPoolsInfoParser();
    return new NetworkHistory(network, ordersParser, poolParser);
}
export class NetworkHistory {
    constructor(network, ordersParser, poolsParser) {
        this.network = network;
        this.ordersParser = ordersParser;
        this.poolsParser = poolsParser;
    }
    async getAllByAddress(address, displayLatest) {
        const ops = [];
        let uOffset = 0;
        const limit = 100;
        while (ops.length < displayLatest) {
            const [txs, total] = await this.network.getUTxsByAddress(address, { offset: uOffset, limit: 100 });
            for (const tx of txs) {
                const op = this.parseOp(tx, false, [address]);
                if (op)
                    ops.push(op);
            }
            if (uOffset < total)
                uOffset += limit;
            else
                break;
        }
        let offset = 0;
        while (ops.length < displayLatest) {
            const [txs, total] = await this.network.getTxsByAddress(address, { offset, limit: 100 });
            for (const tx of txs) {
                const op = this.parseOp(tx, true, [address]);
                if (op)
                    ops.push(op);
            }
            if (offset < total)
                offset += limit;
            else
                break;
        }
        return ops;
    }
    async getAllByAddresses(addresses, displayLatest) {
        const ops = [];
        for (const addr of addresses) {
            let uOffset = 0;
            const limit = 100;
            while (ops.length < displayLatest) {
                const [txs, total] = await this.network.getUTxsByAddress(addr, { offset: uOffset, limit: 100 });
                for (const tx of txs) {
                    const op = this.parseOp(tx, false, addresses);
                    if (op)
                        ops.push(op);
                }
                if (uOffset < total)
                    uOffset += limit;
                else
                    break;
            }
            let offset = 0;
            while (ops.length < displayLatest) {
                const [txs, total] = await this.network.getTxsByAddress(addr, { offset, limit: 100 });
                for (const tx of txs) {
                    const op = this.parseOp(tx, true, addresses);
                    if (op)
                        ops.push(op);
                }
                if (offset < total)
                    offset += limit;
                else
                    break;
            }
        }
        return ops;
    }
    parseOp(tx, confirmed, addresses) {
        const outputOrder = tx.outputs
            .map(o => {
            const op = this.ordersParser.parse(o);
            return op ? [op, o] : undefined;
        })
            .find(x => !!x);
        if (outputOrder) {
            const [summary, output] = outputOrder;
            if (!output.spentTransactionId)
                return {
                    type: "order",
                    timestamp: tx.timestamp,
                    txId: tx.id,
                    boxId: output.boxId,
                    status: confirmed ? "submitted" : "pending",
                    order: summary
                };
        }
        const inputOrder = tx.inputs
            .map(o => {
            const op = this.ordersParser.parse(o);
            return op ? [op, o] : undefined;
        })
            .find(x => !!x);
        const poolOutput = () => tx.outputs.map(o => this.poolsParser.parse(o)).find(x => !!x);
        if (inputOrder && !confirmed) {
            const [summary, input] = inputOrder;
            return {
                type: "order",
                timestamp: tx.creationTimestamp,
                txId: tx.id,
                boxId: input.boxId,
                orderInput: input,
                status: "inProgress",
                order: summary
            };
        }
        if (inputOrder && confirmed) {
            const [summary, input] = inputOrder;
            const pool = poolOutput();
            if (pool) {
                return {
                    type: "order",
                    timestamp: tx.timestamp,
                    txId: tx.id,
                    boxId: input.boxId,
                    status: "executed",
                    order: summary
                };
            }
            else {
                return {
                    type: "refund",
                    timestamp: tx.timestamp,
                    txId: tx.id,
                    status: "executed",
                    operation: summary.type
                };
            }
        }
        const pool = poolOutput();
        if (pool) {
            const rewardLP = tx.outputs
                .filter(o => addresses.includes(o.address))
                .flatMap(o => o.assets)
                .find(a => a.tokenId === pool.lp.asset.id);
            if (rewardLP)
                return {
                    type: "setup",
                    timestamp: tx.timestamp,
                    txId: tx.id,
                    status: "executed",
                    pool: pool,
                    reward: AssetAmount.fromToken(rewardLP)
                };
        }
        return undefined;
    }
}
//# sourceMappingURL=data:application/json;base64,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